import {Component, Input, OnInit} from '@angular/core';
import {TextModel} from "@white-label/components/page-builder/models/text.model";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {FormsModule} from "@angular/forms";
import {QuillEditorComponent} from "ngx-quill";
import {TranslateModule} from "@ngx-translate/core";
import {MediaStore} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.store";
import {ButtonComponent} from "@white-label/components/white-label/button/button.component";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";

@Component({
    selector: 'white-label-text-reach-editor',
    standalone: true,
    imports: [
        FormsModule,
        QuillEditorComponent,
        TranslateModule,
        ButtonComponent
    ],
    providers: [],
    templateUrl: './reach-editor.component.html'
})
export class ReachEditorComponent implements OnInit{
    @Input() componentModel: TextModel = new TextModel();
    @Input() isEditing = false;
    content = '';
    quillEditor: any = '';
    editorModules = {
        toolbar: [
            [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image', 'video'],
            ['clean']
        ],
    };
    constructor(public mainStore: MainStoreService,
                public pageBuilderStore: PageBuilderStore) {
    }

    async ngOnInit() {
        // Dynamically load styles
        await this.loadQuillStyles();
        this.content = this.componentModel.content.value;
    }

    private async loadQuillStyles() {
        // Load the Snow theme
        await import('quill/dist/quill.snow.css');
        // If needed, you can also dynamically load other themes like:
        // await import('quill/dist/quill.bubble.css');
    }

    save(){
        this.pageBuilderStore.sectionData.data.content.value = this.componentModel.content.value;
        this.pageBuilderStore.sideBarIsOpen = false;
        this.pageBuilderStore.sectionData = null;
        this.pageBuilderStore.componentData = null;
    }

    cancel(){
        this.componentModel.content.value = this.content;
        this.pageBuilderStore.sideBarIsOpen = false;
        this.pageBuilderStore.sectionData = null;
        this.pageBuilderStore.componentData = null;
    }

    autocompleteAndSave(){

    }

}
